var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#000000;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 16.2,
    y1: 5,
    x2: 27.3,
    y2: 5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 15.7,
    width: 17.4,
    height: 0.6
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "10.3,21.9 4,16 10.3,10.1 10.7,10.5 4.9,16 10.7,21.5  "
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "28,28 14.9,28 14.9,23 15.6,23 15.6,27.4 27.3,27.4 27.3,4.6 15.6,4.6 15.6,9 14.9,9 14.9,4 28,4  "
  })), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 15.9,
    y1: 9,
    x2: 15.9,
    y2: 4.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 27,
    y1: 5.3,
    x2: 27,
    y2: 27.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 15.6,
    y1: 27.1,
    x2: 26.8,
    y2: 27.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 15.9,
    y1: 23,
    x2: 15.9,
    y2: 26.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 11,
    y1: 10.8,
    x2: 5.5,
    y2: 15.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 11,
    y1: 21.2,
    x2: 5.5,
    y2: 16.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 6,
    y1: 16.3,
    x2: 21.9,
    y2: 16.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 6,
    y1: 15.6,
    x2: 21.9,
    y2: 15.6
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout-icon.da86bf6d0e6e55be7b54f03dcd5c8ab8.svg";
export { ForwardRef as ReactComponent };